import * as R from "ramda";
import React, {Component} from "react";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import {defaultTableChange} from "../../../../../modules/custom/customTable";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";

class InventoryUnitTable extends Component {
    constructor(props) {
        super(props);
        this.tableConfig = props.tableConfig;
        this.tableColumns = [
            {
                name: "",
                label: "No",
                options: {
                    customBodyRender: (_, tableMeta) => {
                        const {page, rowsPerPage} = tableMeta.tableState;
                        const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                        return <>{rowNumber}</>;
                    },
                    sort: false,
                },
            },
            ...this.tableConfig,
        ];

        if (this.props.actionButtons || typeof this.props.actionButtons === "function") {
            this.tableColumns.push({
                name: "",
                label: "Aksi",
                options: {
                    customBodyRender: (_, tableMeta) => {
                        return (
                            <>
                                {this.props.actionButtons(tableMeta)}
                            </>
                        );
                    },
                    setCellProps: () => ({
                        style: {width: "5%"},
                    }),
                    sort: false,
                },
            });
        }

        this.state = {
            loading: false,
        };
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    handleChangeStatus = (index, value) => {
        this.handleTriggerLoading();
        if (typeof this.props.onChangeStatus === "function") {
            this.props.onChangeStatus(index, value);
        }
        this.handleTriggerLoading();
    };

    handleOnChangePage = (tableState) => {
        let limit = tableState.rowsPerPage;
        let page = tableState.page + 1;
        if (typeof this.props.onChangePage === "function") {
            this.props.onChangePage(page, limit, (prevValue) => ({
                ...prevValue,
                pagination: {
                    ...prevValue.pagination,
                    page: page,
                    limit: limit,
                }
            }));
        }
    }

    handleOnChangeRowsPerPage = (tableState) => {
        let limit = tableState.rowsPerPage;
        if (typeof this.props.onChangeRowsPerPage === "function") {
            this.props.onChangeRowsPerPage(1, limit, (prevValue) => ({
                ...prevValue,
                pagination: {
                    ...prevValue.pagination,
                    count: 0,
                    page: 1,
                    limit: limit,
                }
            }));
        }
    }

    render() {
        return (
            <>
                <SimpleDataTable
                    title={this.props.title}
                    tableKey={this.props.tableKey}
                    data={!R.isNil(this.props.data) ? this.props.data : []}
                    columns={this.tableColumns}
                    rowsPerPage={this.props.pagination ? this.props.pagination.limit : 5}
                    toCount={this.props.pagination?.count}
                    options={{
                        ...defaultTableChange(
                            (tableState) => this.handleOnChangePage(tableState),
                            (tableState) => this.handleOnChangeRowsPerPage(tableState)),
                        ...this.props.options,
                    }}
                    footerAdditionalButtons={this.props.additionalButtons}
                />
                <SimpleLoadingOverlay active={this.state.loading}/>
            </>
        );
    }
}

export default InventoryUnitTable;
